var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-field",class:[{'has-errors': _vm.hasErrors}, 'form-field--' + _vm.def.TypeName]},[_c('div',{staticClass:"static-text",style:(_vm.def.CSSStyles.join(' ')),domProps:{"innerHTML":_vm._s(_vm.def.Text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }